import React, { Fragment, useEffect } from "react";
import { SVCNTURL, UI_URL } from "@data/GlobalData.js";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import { PROCESS_ADDDETAILS, UPDATESITEMAP } from "@genericComponents/CFW.js";
import { Folders, GetFile } from "@genericComponents/FileFW.js";
import { MaintainSiteMap } from "@genericComponents/PFW.js";
import { PostData } from "@genericComponents/SFW.js";
import {
  GetState,
  RemoveState,
  SetState,
} from "@genericComponents/StoreToolkit.js";
const UploadFile = await import("@asyncImports/UploadFile.js").then(
  (mod) => mod.UploadFile,
);
const ConvertUrlToBase64 =
  await import("@asyncImports/ConvertUrlToBase64.js").then(
    (mod) => mod.ConvertUrlToBase64,
  );
const ConvertBase64ToPng =
  await import("@asyncImports/ConvertBase64ToPng.js").then(
    (mod) => mod.ConvertBase64ToPng,
  );
const GetDynamicOptionTypeId =
  await import("@asyncImports/GetDynamicOptionTypeId.js").then(
    (mod) => mod.GetDynamicOptionTypeId,
  );
const MatchingFieldsOnly =
  await import("@asyncImports/MatchingFieldsOnly.js").then(
    (mod) => mod.MatchingFieldsOnly,
  );
const CleanUrl = await import("@asyncImports/CleanUrl.js").then(
  (mod) => mod.CleanUrl,
);
export const HandleSEO = () => {
  const CFW_HANDLE_SEO_PROCESS = "HANDLE_SEO_PROCESS";
  const Response_HandleSEOSiteMapData = "HandleSEOSiteMapData";
  const updateSiteMap = useGenericStore(UPDATESITEMAP);
  let siteMapParam;
  const GeneratePNGFileNameFromUrl = (paramUrl) => {
    let fileName = CleanUrl(paramUrl.toLowerCase());
    fileName = (fileName.split(UI_URL)[1] ?? "/home").substring(1);
    if (fileName.length > 100 && fileName.includes("-")) {
      fileName = fileName.substring(fileName.indexOf("-") + 1);
    }
    fileName = `${(fileName ?? "home").replace(/\W/g, "-")}.png`;
    return fileName;
  };
  const ConvertImageIfPng = () => {
    siteMapParam = { ...updateSiteMap };
    const imageUrlToConvert =
      updateSiteMap.Image ??
      GetDynamicOptionTypeId(updateSiteMap?.ProductCode).Image;
    if (imageUrlToConvert) {
      ConvertUrlToBase64(imageUrlToConvert, ({ base64, name }) => {
        ConvertBase64ToPng(base64, name, false).then((results) => {
          results.fileName = GeneratePNGFileNameFromUrl(updateSiteMap?.Url);
          UploadFile(
            results.blob,
            Folders.SiteMapImage,
            results.fileName,
            () => {
              siteMapParam.Image = GetFile(
                Folders.SiteMapImage,
                results.fileName,
                null,
                true,
              );
              UpdateSiteMap();
            },
          );
        });
      });
    } else {
      UpdateSiteMap();
    }
  };
  const UpdateSiteMap = () => {
    const param = MatchingFieldsOnly(siteMapParam, MaintainSiteMap);
    if (isNaN(param.Title)) {
      param.Process = param.Process ?? PROCESS_ADDDETAILS;
      const canonnicalElement = document.querySelector("link[rel='canonical']");
      if (canonnicalElement) {
        param.CanonicalUrl = canonnicalElement.href;
      }
      PostData(
        [SVCNTURL, "MaintainSiteMap"].join(""),
        param,
        Response_HandleSEOSiteMapData,
        () => {
          RemoveState(CFW_HANDLE_SEO_PROCESS);
          RemoveState(UPDATESITEMAP);
        },
      );
    }
  };
  useEffect(() => {
    if (updateSiteMap?.Url && !GetState(CFW_HANDLE_SEO_PROCESS)) {
      SetState(CFW_HANDLE_SEO_PROCESS, true);
      ConvertImageIfPng();
    }
    return () => {};
  }, [updateSiteMap]);
  return <Fragment />;
};
